import Actions from '../Collection/actions'

const actions = Actions.get('HIGHLIGHT_');

export default actions;
